(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-start.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-start.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  sweRectangleBounds,
  mapDefaults,
  createMap
} = svs.tur.lyckoplatsen.map;
const logger = svs.core.log.getLogger('module:lyckoplatsen');
function getStartMapHandler() {
  let map;
  let options;
  let results;
  let sweRec;
  let tlEnd;
  let markers = [];
  let circles = [];

  let _isDestroying = false;
  return {
    createMap(mapOptions) {
      var _svs$lyckoplatsen$dat, _svs$lyckoplatsen$dat2;
      options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options);
      results = (_svs$lyckoplatsen$dat = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 || (_svs$lyckoplatsen$dat2 = _svs$lyckoplatsen$dat2.startPage) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.recentResults) !== null && _svs$lyckoplatsen$dat !== void 0 ? _svs$lyckoplatsen$dat : [];
      this.addElements();
      this.mapFitBounds();
      this.animateShowText();
      this.animatePlacesLoop();
      this.animateEnd();
      return map;
    },
    mapFitBounds() {
      if (map && sweRec) {
        const pb = svs.core.detect.breakpoint.equals('xs') ? [0, 128] : [0, 218];
        const pt = svs.core.detect.breakpoint.equals('xs') ? [0, 4] : [0, 36];
        map.fitBounds(sweRec.getBounds(), {
          paddingBottomRight: pb,
          paddingTopLeft: pt,
          animate: false
        });
      }
    },
    animateReset() {
      gsap.killTweensOf('.gsap-result-text');
      gsap.killTweensOf('.gsap-png-marker');
      gsap.killTweensOf('.gsap-winner-circle');
      gsap.set('.gsap-result-text', {
        opacity: 0,
        y: 24
      });
      gsap.set('.gsap-png-marker', {
        opacity: 0,
        scale: 0
      });
      gsap.set('.gsap-winner-circle', {
        opacity: 0
      });
      if (tlEnd) {
        tlEnd.kill();
        tlEnd = null;
      }
    },
    animatePlay() {
      this.animateReset();
      this.animateShowText();
      this.animatePlacesLoop();
      this.animateEnd();
    },
    animateShowText() {
      gsap.set('.gsap-result-text', {
        opacity: 0,
        y: 24
      });
      gsap.to('.gsap-result-text', {
        opacity: 1,
        y: 0,
        delay: 1,
        duration: 2,
        ease: 'power4.out'
      });
    },
    animatePlacesLoop() {
      const markers = gsap.utils.toArray('.gsap-png-marker');
      const circles = gsap.utils.toArray('.gsap-winner-circle');

      gsap.set(markers, {
        opacity: 0,
        scale: 0
      });
      gsap.set(circles, {
        opacity: 0
      });
      gsap.delayedCall(2, () => {
        gsap.to(markers, {
          keyframes: [{
            opacity: 1,
            scale: 1,
            duration: 0.75,
            ease: 'power4.out'
          }, {
            opacity: 0,
            delay: 0.75,
            scale: 0,
            duration: 0.75
          }, {
            duration: 1.5
          }],
          stagger: 0.75,
          repeat: -1,
          repeatDelay: 0
        });
        gsap.to(circles, {
          keyframes: [{
            opacity: 1,
            duration: 0.75,
            ease: 'power1.out'
          }, {
            opacity: 1,
            duration: 2.50
          }, {
            opacity: 0,
            duration: 0.50,
            ease: 'power1.in'
          }],
          stagger: 0.75,
          repeat: -1,
          repeatDelay: 0
        });
      });
    },
    animateEnd() {
      gsap.set('.gsap-choose-btn', {
        opacity: 0,
        y: 24
      });
      gsap.set('.gsap-guide-button', {
        opacity: 0,
        y: 24
      });
      tlEnd = gsap.timeline({
        delay: 5
      });
      tlEnd.to('.gsap-result-text', {
        opacity: 0,
        y: 24,
        duration: 0.75,
        ease: 'power4.out'
      });
      tlEnd.to('.gsap-choose-btn', {
        opacity: 1,
        y: 0,
        duration: 0.75,
        ease: 'power4.out'
      }, '-=0.25');
      tlEnd.to('.gsap-guide-button', {
        opacity: 1,
        y: 0,
        duration: 0.75,
        ease: 'power4.out'
      }, '-=0.35');
    },
    addElements() {
      let resultsPane = map.getPane('pane-results');
      if (!resultsPane) {
        resultsPane = map.createPane('pane-results');
        resultsPane.style.zIndex = 651;
        resultsPane.style.pointerEvents = 'none';
      }
      sweRec = leaflet.rectangle(sweRectangleBounds, {
        color: 'yellow',
        fillOpacity: 0.6,
        weight: 1
      });
      if (results.length) {
        results.forEach(result => {
          const lat = parseFloat(result.location.latitude.replace(',', '.'));
          const lng = parseFloat(result.location.longitude.replace(',', '.'));
          const winCoord = [lat, lng];
          let width = 120;
          let height = 144;
          if (svs.core.detect.breakpoint.current === 'xs') {
            width = 80 * 0.64;
            height = 96 * 0.64;
          } else if (svs.core.detect.formfactor.mobile()) {
            width = 80;
            height = 96;
          }
          const iconUrl = "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/pin3d.png");
          const greenPngIcon = leaflet.divIcon({
            html: "<div style=\"background-image: url('".concat(iconUrl, "'); background-size: contain; background-repeat: no-repeat; background-position: center; width: ").concat(width, "px; height: ").concat(height, "px;\"></div>"),
            iconSize: [width, height],
            iconAnchor: [width / 2, height * 0.75],
            className: 'green-png-marker gsap-png-marker'
          });
          const greenPngMarker = leaflet.marker(winCoord, {
            icon: greenPngIcon,
            pane: 'pane-results',
            zIndexOffset: 200
          });
          greenPngMarker.addTo(map);
          markers.push(greenPngMarker);

          const leafletCircle = leaflet.circle(winCoord, {
            radius: result.maxDistanceMeters,
            color: '#1046B7',
            weight: 1,
            fillColor: '#1046B7',
            fillOpacity: 0.18,
            className: 'gsap-winner-circle',
            pane: 'pane-results',
            bubblingMouseEvents: false
          });
          leafletCircle.addTo(map);
          circles.push(leafletCircle);
        });
      }
    },
    removeMap() {
      if (_isDestroying) {
        return;
      }
      _isDestroying = true;

      try {
        gsap.killTweensOf('.gsap-result-text');
        gsap.killTweensOf('.gsap-png-marker');
        gsap.killTweensOf('.gsap-winner-circle');
        gsap.killTweensOf('.gsap-choose-btn');
        gsap.killTweensOf('.gsap-guide-button');
        if (tlEnd) {
          tlEnd.kill();
          tlEnd = null;
        }
      } catch (err) {
        logger.debug('Start map, GSAP not removed properly:', err);
      }

      try {
        if (map) {
          map.off('resize');
        }
      } catch (err) {
        logger.debug('Start map, map listeners not removed properly:', err);
      }

      try {
        if (map && typeof map.closePopup === 'function') {
          map.closePopup();
        }
      } catch (err) {
        logger.debug('Start map, error closing map popup:', err);
      }
      try {
        if (map && typeof map.closeTooltip === 'function') {
          map.closeTooltip();
        }
      } catch (err) {
        logger.debug('Start map, error closing map tooltip:', err);
      }

      try {
        markers.forEach(marker => {
          if (marker && marker.remove) {
            marker.remove();
          }
        });
        markers = [];
      } catch (err) {
        logger.debug('Start map, error removing markers:', err);
      }

      try {
        circles.forEach(circle => {
          if (circle && circle.remove) {
            circle.remove();
          }
        });
        circles = [];
      } catch (err) {
        logger.debug('Start map, error removing circles:', err);
      }

      try {
        if (sweRec && sweRec.remove) {
          sweRec.remove();
        }
        sweRec = null;
      } catch (err) {
        logger.debug('Start map, error removing Sweden rectangle:', err);
      }

      try {
        var _options;
        const container = (_options = options) !== null && _options !== void 0 && _options.nodeId ? document.getElementById(options.nodeId) : null;
        container === null || container === void 0 || container.querySelectorAll('.gsap-png-marker, .gsap-winner-circle, .gsap-result-text, .gsap-choose-btn, .gsap-guide-button').forEach(el => el.remove());
      } catch (err) {
        logger.debug('Start map, error removing DOM elements:', err);
      }

      try {
        if (map) {
          map.off();
          map.remove();
        }
        map = null;
      } catch (err) {
        logger.debug('Start map, the map is not removed properly:', err);
      }

      options = null;
      results = null;
      _isDestroying = false;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getStartMapHandler
});

 })(window);